fragment annotationSetDetails on AnnotationSetType {
  id
  sentence {
    id
  }
  overlay {
    id
  }
  annotations {
    id
    index
    style
  }
}
